import { createActionCreator } from "deox";

import { TokenHttpResponse } from "../../parentApi";
export const cryptoTokenLoading = createActionCreator("cryptoTokenLoading");
export const cryptoTokenError = createActionCreator("cryptoTokenError");
export const cryptoTokenLoaded = createActionCreator(
  "cryptoTokenLoaded",
  (resolve) => (tokens: TokenHttpResponse[]) => resolve(tokens)
);
